import EditItem from '@/common/components/EditItem';
import {
	LINKED_PRODUCT_COLUMNS,
	SUPER_PRODUCT_MESSAGES,
} from '../../../../constants/superProduct';
import { Products, ProductsTitle } from './LinkedProducts.styled';

const LinkedProducts = ({ products }) => {
	return (
		<Products>
			<ProductsTitle>{SUPER_PRODUCT_MESSAGES.PRODUCTS}</ProductsTitle>
			{products.length === 0 && <div>{SUPER_PRODUCT_MESSAGES.NO_PRODUCTS}</div>}
			{products.length > 0 && (
				<table className='styled-table'>
					<thead>
						<tr>
							{LINKED_PRODUCT_COLUMNS.map((column) => (
								<th key={column}>{column}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{products.map((product) => (
							<tr key={product._id}>
								<td>{product.name}</td>
								<td>{product.short}</td>
								<td>
									<EditItem
										link={`/settings/product/show/${product._id}`}
										width={40}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</Products>
	);
};

export default LinkedProducts;
